import { Box, Skeleton, SxProps, Theme, Typography } from '@mui/material';
import { distributorsContext } from 'pages/distributorManagement/distributorManagementResolver';
import { useContext } from 'react';
import { TableDataContext } from '../../shared/types';
import { formatZeroDecimalMoney, formatZeroDecimalNumber } from '../../shared/utility';
import { DistributorsData } from '../../types/backend';

const toolBarStyles: SxProps<Theme> = {
    marginBottom: 2,
    marginTop: 2,
    padding: 2,
    display: 'flex',
    gap: 1.5,
    justifyContent: 'space-between',
    minWidth: '100%',
    backgroundColor: 'lightgray',
    gridAutoColumns: 'minmax(0, 1fr)',
    gridAutoFlow: 'column',
};

interface CurrentPricesSummaryProps {
    matchingCustomer: DistributorsData;
}

export function CurrentPricesSummary({ matchingCustomer }: CurrentPricesSummaryProps) {
    const summaryContext = useContext<TableDataContext<DistributorsData>>(distributorsContext);

    const summary = [
        { header: 'Current Tier', value: matchingCustomer?.priceTier },
        { header: 'Customer Trigger', value: matchingCustomer?.priceTrigger },
        { header: 'Customer Trigger Timing', value: matchingCustomer?.timing, width: '100px' },
        { header: 'Region', value: matchingCustomer?.region },
        { header: 'Pricing Owner', value: matchingCustomer?.pricingOwner },
        { header: 'Territory Sales Leader', value: matchingCustomer?.territorySalesLeader },
        { header: 'Territory Sales Rep', value: matchingCustomer?.territorySalesRep },
        { header: 'TTM Revenue', value: formatZeroDecimalMoney(Math.round(Number(matchingCustomer?.ttmRevenue))) },
        { header: 'TTM Pounds', value: formatZeroDecimalNumber(Math.round(Number(matchingCustomer?.ttmPounds))) },
        { header: 'Deviation Count', value: matchingCustomer?.deviationCount },
        { header: 'Expiring Soon', value: matchingCustomer?.alerts },
        { header: 'POS Flag', value: matchingCustomer?.isPosAccount ? 'Yes' : 'No' },
        { header: 'Truckload (T/L) Flag', value: matchingCustomer?.isTruckloadAccount ? 'Yes' : 'No' },
    ];

    return (
        <Box sx={toolBarStyles}>
            {summary.map((item) => (
                <Box key={item.header}>
                    <Typography variant='body2' gutterBottom>
                        {item.header}
                    </Typography>
                    <Typography variant='body2' sx={{ width: item.width }}>
                        {summaryContext.response?.isLoading ? <Skeleton width={100} /> : <strong>{item.value}</strong>}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}
